import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import * as $ from 'jquery';
import { HeadService } from 'src/app/services/common/headservice';
import { ModuleMenu } from 'src/app/models/common';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ist-institutional-review-board',
  templateUrl: './ist-institutional-review-board.component.html',
  styleUrls: ['./ist-institutional-review-board.component.scss']
})
export class IstInstitutionalReviewBoardComponent implements OnInit, IDeactivateComponent {

  formFields;
  ApplicationID: string;
  reviewBoardOptions = [];
  permission: string = "";
  operations: any = [];
  userType: string = "";
  content: any;
  menudata: ModuleMenu;
  staticformFields: any;
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  institutionalReviewBoardForm: UntypedFormGroup;

  constructor(
    private modalService: NgbModal,
    private appFunctions: AppFunctionsService,
    private summaryService: IstSummaryService,
    private datashareService: IstDataShareService,
    public route: ActivatedRoute,
    private router: Router,
    private header: HeadService,
    public commonService: CommonService,
    private userService: UserService
  ) { 
    this.setFormPermissions();
  }

  ngOnInit() {
    this.getStaticFiledsData('SCR-005');
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    
    setTimeout(() => {
      this.setFormPermissions();
      if (this.permission == "view") {
        this.institutionalReviewBoardForm.disable();
      }
      else 
      this.institutionalReviewBoardForm.enable();
    }, 700);
    this.userType = this.userService.getUserType();
    this.institutionalReviewBoardForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      APPLICATION_ID: new UntypedFormControl(null),
      NAME: new UntypedFormControl(null, [Validators.required]),
      WEB_SITE: new UntypedFormControl("", [Validators.required, Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]),
      BOARD_TYPE_ID: new UntypedFormControl(null, [Validators.required]),
      ADDRESS: new UntypedFormControl(null),
      EMAIL: new UntypedFormControl(null),
      PHONE: new UntypedFormControl("", [Validators.maxLength(20)]),
      NOTES: new UntypedFormControl(null)
    });

    if (this.permission != "view") {
      this.operations = [
        { name: 'Save', type: 'submit', callback: this.save, self: this }
      ];
    }
    else {
      this.operations = [];
      this.institutionalReviewBoardForm.disable();
    }

    this.GetScreenMasterData();
    this.GetScreenData();
  }

  private setFormPermissions()
  {
    this.permission = "";
    let tempPermission = this.commonService.getPagePermission("IST04");
    if (tempPermission != null && tempPermission != undefined) {
      this.permission = tempPermission.toLowerCase();
    } 
  if (this.permission == "view") {
   // this.institutionalReviewBoardForm.disable();
   this.operations = [];
  }
  else {
    this.operations = [
      { name: 'Save', type: 'submit', callback: this.save, self: this }
    ]
  }
}
  onCallbackOperation(opr) {
    opr.callback(this.summaryService, this.institutionalReviewBoardForm, this.ApplicationID, this.extendedForm, this.validateControls);
  }

  GetScreenMasterData() {
    this.summaryService.getScreenDataForEdit("api/ISTReviewBoard/GetReviewBoardMasterData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.reviewBoardOptions = summary["MasterData1"];
      this.reviewBoardOptions = [{ label: "Select", value: "", checked: true }].concat(this.reviewBoardOptions);
    });
  }

  GetScreenData() {
    if (this.ApplicationID != "" && this.ApplicationID != undefined && this.ApplicationID != null) {
      this.summaryService.getScreenDataForEdit("api/ISTReviewBoard/GetReviewBoardData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
        if (summary != null && summary != undefined && summary != "") {
          this.institutionalReviewBoardForm.patchValue({
            ID: summary["ID"],
            APPLICATION_ID: summary["APPLICATION_ID"],
            NAME: summary["NAME"],
            WEB_SITE: summary["WEB_SITE"],
            BOARD_TYPE_ID: summary["BOARD_TYPE_ID"],
            ADDRESS: summary["ADDRESS"],
            EMAIL: summary["EMAIL"],
            PHONE: summary["PHONE"],
            NOTES: summary["NOTES"],
          })
          if (this.extendedForm != null && this.extendedForm != undefined) {
            this.extendedForm.rowid = summary["ID"];
            this.extendedForm.getResponse();
          }

        }
      });
    }
  }

  save() {
    if (this.validateControls()) {
      this.institutionalReviewBoardForm.markAsPristine();
      if (this.ApplicationID == null || this.ApplicationID == undefined || this.ApplicationID == "") {
        this.SaveIST_GI_APP().subscribe((res) => {
          if (res.Status === 0) {
            this.ApplicationID = res["TransactionID"];
            this.datashareService.setApplicationID(this.ApplicationID);
            var formData = this.institutionalReviewBoardForm.value;
            formData.APPLICATION_ID = this.ApplicationID;
            this.summaryService.Insert("api/ISTReviewBoard/Insert", formData).subscribe(summary => {
              if (summary.Status === 0) {
                this.extendedForm.saveControls(summary.TransactionID, this.ApplicationID, summary.TransactionCode).subscribe(result1 => {
                  if (result1.Status === 0) {
                    this.commonService.SuccessBanner(summary.Message);
                    if (this.extendedForm != null && this.extendedForm != undefined) {
                      this.extendedForm.IsFormToched=false;
                    }
                    this.refreshPage(this.ApplicationID);
                  }
                  else {
                    this.commonService.ValidationBanner(result1.Message);
                    this.refreshPage(this.ApplicationID);
                  }
                });
              }
              else {
                this.commonService.ValidationBanner(summary.Message);
              }
            });
          }
          else {
            this.commonService.ValidationBanner(res.Message);
          }
        });
      }
      else {
        var formData = this.institutionalReviewBoardForm.value;
        this.summaryService.getAppSubmitValidations("api/ISTReviewBoard/IST_APPInActiveIRBValidation?BoardTypeId=" + formData.BOARD_TYPE_ID
          // +"&PkId="+ this.ApplicationID
        ).subscribe((resultInactive) => {
          if (resultInactive != null && resultInactive != undefined) {
            if (resultInactive.Status == 0) {
              let dataMsg = resultInactive.Data.Validations[0].FiledsData.join("</br>");
              this.commonService.ValidationBanner(dataMsg);
            }
            else {
debugger
              formData.APPLICATION_ID = this.ApplicationID;
              this.summaryService.Insert("api/ISTReviewBoard/Update", formData).subscribe(summary => {
                if (summary.Status === 0 || summary.ErrorCode === "NOCHANGES") {
                  this.extendedForm.saveControls(summary.TransactionID, this.ApplicationID, summary.TransactionCode).subscribe(result1 => {
                    if (result1.ErrorCode === "NOCONTROLS") {
                      if (summary.Status === 0)
                      this.commonService.SuccessBanner(summary.Message);
                      if (this.extendedForm != null && this.extendedForm != undefined) {
                        this.extendedForm.IsFormToched=false;
                      }
                      else {
                        this.commonService.ValidationBanner(summary.Message);
                        
                      }
                    }
                    else {
                      if (summary.ErrorCode === "NOCHANGES" && result1.ErrorCode === "NOCHANGES") {
                        this.commonService.ValidationBanner(summary.Message);
                      }
                      else 
                      {
                        if (this.extendedForm != null && this.extendedForm != undefined) {
                          this.extendedForm.rowid = summary.TransactionID;
                          this.extendedForm.getResponse();
                        }
                        this.commonService.SuccessBanner("Institutional Review Board Details saved successfully");
                        if (this.extendedForm != null && this.extendedForm != undefined) {
                          this.extendedForm.IsFormToched=false;
                        }
                      }
                    }
                  });
                }
                else {
                  this.commonService.ValidationBanner(summary.Message);
                }
              });
            }
          }
        });
        // this.institutionalReviewBoardForm.markAsPristine();
      }
    }

  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.institutionalReviewBoardForm.value;

    if (this.staticformFields?.NAME.IS_MANDATORY && this.staticformFields?.NAME.IS_Display) {
      if (formData.NAME === null || formData.NAME === "") {
        $("#NAME").addClass("ng-touched ng-invalid validate-error");
        $("#NAME").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.NAME.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#NAME").addClass("ng-untouched ng-valid");
        $("#NAME").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.WEB_SITE.IS_MANDATORY && this.staticformFields?.WEB_SITE.IS_Display) {
      if (formData.WEB_SITE === null || formData.WEB_SITE === "") {
        $("#WEB_SITE").addClass("ng-touched ng-invalid validate-error");
        $("#WEB_SITE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.WEB_SITE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        const website = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
        if (formData.WEB_SITE.match(website)) {
          $("#WEB_SITE").addClass("ng-untouched ng-valid");
          $("#WEB_SITE").removeClass("ng-touched ng-invalid validate-error");
        }
        else {
          $("#WEB_SITE").addClass("ng-touched ng-invalid validate-error");
          $("#WEB_SITE").removeClass("ng-untouched ng-valid");
          message += `Please enter valid ${this.staticformFields?.WEB_SITE.LABEL_NAME} <br/>`;
          isValid = false;
        }
      }
    }

    if (this.staticformFields?.BOARD_TYPE_ID.IS_MANDATORY && this.staticformFields?.BOARD_TYPE_ID.IS_Display) {
      if (formData.BOARD_TYPE_ID === null || formData.BOARD_TYPE_ID === "") {
        $("#BOARD_TYPE_ID").addClass("ng-touched ng-invalid validate-error");
        $("#BOARD_TYPE_ID").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.BOARD_TYPE_ID.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#BOARD_TYPE_ID").addClass("ng-untouched ng-valid");
        $("#BOARD_TYPE_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.ADDRESS.IS_MANDATORY && this.staticformFields?.ADDRESS.IS_Display) {
      if (formData.ADDRESS === null || formData.ADDRESS === "") {
        $("#ADDRESS").addClass("ng-touched ng-invalid validate-error");
        $("#ADDRESS").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.ADDRESS.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#ADDRESS").addClass("ng-untouched ng-valid");
        $("#ADDRESS").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.EMAIL.IS_Display) {
      if ((formData.EMAIL === null || formData.EMAIL === "" || formData.EMAIL === undefined)
        && this.staticformFields?.EMAIL.IS_MANDATORY) {
        $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
        $("#EMAIL").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.EMAIL.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        if (formData.EMAIL != null && formData.EMAIL != "" && formData.EMAIL != undefined) {
          if (this.commonService.validateEmail(formData.EMAIL)) {
            $("#EMAIL").addClass("ng-untouched ng-valid");
            $("#EMAIL").removeClass("ng-touched ng-invalid validate-error");
          }
          else {
            $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
            $("#EMAIL").removeClass("ng-untouched ng-valid");
            message += `Please enter valid ${this.staticformFields?.EMAIL.LABEL_NAME} <br/>`;
            isValid = false;
          }
        }
      }
    }

    if (this.staticformFields?.PHONE.IS_MANDATORY && this.staticformFields?.PHONE.IS_Display) {
      if (formData.PHONE === null || formData.PHONE === "" || formData.PHONE == undefined) {
        $("#PHONE").addClass("ng-touched ng-invalid validate-error");
        $("#PHONE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.PHONE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#PHONE").addClass("ng-untouched ng-valid");
        $("#PHONE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.NOTES.IS_MANDATORY && this.staticformFields?.NOTES.IS_Display) {
      if (formData.NOTES === null || formData.NOTES === "") {
        $("#NOTES").addClass("ng-touched ng-invalid validate-error");
        $("#NOTES").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.NOTES.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#NOTES").addClass("ng-untouched ng-valid");
        $("#NOTES").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      isValid = false;
      message = message + this.extendedForm.validateControlsMsgs();
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    return isValid;
  }

  OnkeyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
      event.value = '';
    }
  }

  SaveIST_GI_APP() {
    let formData = { "ID": '', "STATUS": 0 };
    return this.summaryService.SaveIstGeneralInfo("api/ISTGeneralInfo/Insert", formData);
  }
  refreshPage(id) {

    this.summaryService.getISTApplicationSummary("api/common/getistapp/" + id).subscribe(data => {
      this.commonService.appId = data.ID;
      this.commonService.setISTApp(data);
      this.menudata = new ModuleMenu();
      this.menudata.module = "IST";
      this.menudata.operation = "Edit";
      this.menudata.appId = id;
      this.menudata.formstate = "Draft";
      this.commonService.setModluleMenu(this.menudata);
      this.header.setHeader(this.menudata);
      this.datashareService.setApplicationID(id);
      this.router.navigate(['/home/ist/my-applications/application-ext/:' + id + '/general_information_request'], { skipLocationChange: true, queryParams: { id: id, app_ext: true, module: "ist", screen_type: "my-applications" } })

    });

    this.institutionalReviewBoardForm.markAsUntouched();
  }
  canExit() {
    if (this.institutionalReviewBoardForm.dirty || this.extendedForm.IsFormToched ) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }
}
